import CloseIcon from 'assets/icons/close.svg';
import WhiteCloseIcon from 'assets/icons/close-white.svg';
import { ICustomModalHeaderProps } from 'interfaces/components/customModal';
import 'react-tooltip/dist/react-tooltip.css';

const CustomModalHeader = ({
  title,
  titlePrefix,
  description,
  descriptionParts,
  onClose
}: ICustomModalHeaderProps) => {
  return (
    <div>
      <div className='flex flex-row items-start justify-between w-full'>
        <p className='text-[28px] leading-[32px] font-semibold'>
          {titlePrefix} {title}
        </p>
        <picture>
          <source
            srcSet={WhiteCloseIcon}
            media='(prefers-color-scheme: dark)'
          />
          <img
            className='cursor-pointer'
            src={CloseIcon}
            alt=''
            onClick={onClose}
          />
        </picture>
      </div>
      <p className='text-[16px] leading-[22.4px] font-light text-gray-700 mt-2'>
        {descriptionParts ? (
          <>
            {descriptionParts.map((part, index) => {
              if (typeof part === 'string') {
                return <span key={index}>{part}</span>;
              }
              return (
                <span
                  key={index}
                  className={`${part.underline ? 'underline' : ''} ${
                    part.bold ? 'font-bold' : ''
                  } ${part.tooltip ? 'cursor-pointer' : ''}`}
                  data-tooltip-id={part.tooltipId}
                  data-tooltip-place='bottom'
                >
                  {part.text}
                </span>
              );
            })}
          </>
        ) : (
          description
        )}
      </p>
    </div>
  );
};

export default CustomModalHeader;
